import { useMutation, useQueryClient } from '@tanstack/react-query';
import { converters as filesConverters } from 'store/files';
import { loaders } from './expenses.loaders';
import { expensesKeys } from './expenses.queries';

export const useExportToXls = () => {
  return useMutation(loaders.exportXls, {
    onSuccess: filesConverters.export,
  });
};

export const useImportExpenses = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.importExpenses, {
    onSuccess: () => {
      return queryClient.invalidateQueries(expensesKeys.lists);
    },
  });
};

export const useExportXlsTemplate = () => {
  return useMutation(loaders.exportXlsTemplate, {
    onSuccess: filesConverters.export,
  });
};

export const useUpdateExpense = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.updateExpense, {
    onSuccess: () => {
      queryClient.invalidateQueries(expensesKeys.lists);
    },
  });
};

export const useUpdateExpenseStatusBulk = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.updateStatusBulk, {
    onSuccess: () => {
      queryClient.invalidateQueries(expensesKeys.lists);
    },
  });
};
